import React from 'react';
import './CpaRecaptcha.scss';
import PropTypes from 'prop-types';
import Recaptcha from 'react-recaptcha';

/* eslint-disable react/jsx-no-bind */
const CpaRecaptcha = (props) => {
  const { callback, siteKey } = props;

  function handleCaptchaCallback() {
    /* eslint-disable-next-line no-console */
    console.log('Recaptcha loaded');
  }

  function handleVerifyCallback(response) {
    callback(true, 'recaptchaVerified', true);
  }

  function handleCaptchaExpiredCallback() {
    callback(false, 'recaptchaVerified', false);
  }

  return (
    <div className="cpa-recaptcha">
      <Recaptcha
        sitekey={siteKey}
        render="explicit"
        expiredCallback={handleCaptchaExpiredCallback}
        onloadCallback={handleCaptchaCallback}
        verifyCallback={handleVerifyCallback}
      />
    </div>
  );
};

CpaRecaptcha.propTypes = {
  callback: PropTypes.func.isRequired,
  siteKey: PropTypes.string.isRequired
};

CpaRecaptcha.displayName = 'CpaRecaptcha';
export { CpaRecaptcha };
